/*
  src/redux/entities/constants.js

  Created by Justin Chang on 5/16/2017.
*/

import { createConstant } from '../helpers';
const createConstantVariable = createConstant('dcm');
export const DCM_TAG_RENDERED = createConstantVariable('DCM_TAG_RENDERED');



// WEBPACK FOOTER //
// ./src/redux/dcm/constants.js